import { useState, useEffect } from "react";
import { FetchCalculationSettings } from "../../api/FetchCalculationSettings";

export interface dataType {
  meta: {
    page?: number;
    limit?: number;
    total?: number;
    current_page?: number;
    last_page?: number;
    first_page?: number;
    first_page_url?: string;
    last_page_url?: string;
    next_page_url?: string;
    previous_page_url?: any;
  };
  data: any[];
}

const default_page_size = 50;

const _data: dataType = {
  meta: {
    page: 1,
    limit: default_page_size,
  },
  data: [],
};

export const useFetchCalculationSettings = (query: {
  provider_id?: number;
  page: number;
  limit: number;
  query_search_value?: string;
}) => {
  const [dataInfo, setDataInfo] = useState(_data);

  useEffect(() => {
    if (!query.provider_id) {
      setDataInfo(_data);
      return;
    }

    const fetchData = async () => {
      const result = await FetchCalculationSettings(query);

      if (result.data.data) {
        for (const item of result.data.data) {
          item["key"] = item.calculation_setting_id;
        }
      }

      setDataInfo(result);
    };

    fetchData();
  }, [query]);

  return dataInfo;
};
